import React from "react";
import { useRoutes } from "react-router-dom";
import { withRouter } from "../../util/with-router";
import { TransitionGroup } from "react-transition-group";
import Profile from "./profile";
import ResetPassword from "./reset-password";
import * as paths from "../../constants/route-paths";
import RBACApplicationAuth from "../../layout/rbac";

function CustomRoutes({ location }) {
  let element = useRoutes([
    {
      path: "",
      element: <RBACApplicationAuth moduleURL={location.pathname} component={Profile} />,
    },
    {
      path: paths.RESET_PASSWORD,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={ResetPassword} />,
    },
  ]);

  return element;
}

class Root extends React.PureComponent {
  render() {
    const { location } = this.props;

    return (
      <div className="clearfix" style={{ width: "100%" }}>
        <TransitionGroup>
          <CustomRoutes location={location} />
        </TransitionGroup>
      </div>
    );
  }
}
export default withRouter(Root);
